<template>

    <div class="profile-statistic-wrap">
        <div class="profile-statistic">
            <div class="single-pofile-statistic">
                <a href="#">
                    <h2>{{ profilestatistic && profilestatistic.totalPost ? numberFormat(profilestatistic.totalPost) : 0 }}</h2>
                    <p>POSTS</p>
                </a>
            </div>
            <div class="single-pofile-statistic">
                <a href="#">
                    <h2>{{ profilestatistic && profilestatistic.totalStories ? numberFormat(profilestatistic.totalStories) : 0 }}</h2>
                    <p>STORIES</p>
                </a>
            </div>
            <div class="single-pofile-statistic">
                <a href="#" @click="following">
                    <h2>{{ profilestatistic && profilestatistic.following ? numberFormat(profilestatistic.following) : 0 }}</h2>
                    <p>FOLLOWING</p>
                </a>
            </div>
            <div class="single-pofile-statistic">
                <a href="#" @click="followers">
                    <h2>{{ profilestatistic && profilestatistic.followers ? numberFormat(profilestatistic.followers) : 0 }}</h2>
                    <p>FOLLOWERS</p>
                </a>
            </div>
            <div class="single-pofile-statistic">
                <a href="#">
                    <h2>{{ profilestatistic && profilestatistic.wordsread ? numberFormat(profilestatistic.wordsread) : 0 }}</h2>
                    <p>WORDS READ</p>
                </a>
            </div>
        </div><!-- /. profile-statistic-wrap -->


        <div class="profile-social" v-if="profilestatistic && profilestatistic.socialmedia">
            <a target="_blank" v-for="(data, index) in profilestatistic.socialmedia" :href="data.link" :key="index">
                <img v-if="data.name == 'twitter'" src="../../assets/icon/twitter.svg" alt="twitter" />
                <img v-if="data.name == 'instagram'" src="../../assets/icon/instagram.svg" alt="instagram" />
                <img v-if="data.name == 'facebook'" src="../../assets/icon/facebook.svg" alt="facebook" />
                <img v-if="data.name == 'snapchat'" src="../../assets/icon/snapchat.svg" alt="snapchat" />
            </a>
        </div><!-- /. profile-social -->

    </div>

</template>



<script>

import { EventBus } from '../../main';

export default {
  name: "profile-statistic",
  props: ['profilestatistic'],

  data() {
      return {
        msgModal:false
      }
  },

  methods:{

    followers() {
        EventBus.$emit('followersmodal',true);
    },

    following() {
        EventBus.$emit('followingmodal',true);
    },

    numberFormat(value) {
      if(value>=1000000000000) {
          value=(value/1000000000000)+"TB"
      } else if(value>=1000000000) {
          value=(value/1000000000)+"B"
      } else if(value>=1000000){
          value=(value/1000000)+"M"
      } else if(value>=1000) {
          value=(value/1000)+"K";
      }

      return value;
    }

  },

}

</script>
